import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import SegmAnnoLabelList from "../../components/SegmAnnoLabel/SegmAnnoLabelList";
import CSVImportModal from "../../components/CSVImportModal";
import "./SegmAnnoLabelListPage.css";

const SegmAnnoLabelListPage = () => {
  const location = useLocation();
  const [refreshData, setRefreshData] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const dicomId = searchParams.get("dicom_id");
  
  const createLink = dicomId 
    ? `/segm_anno_labels/create?dicom_id=${dicomId}` 
    : "/segm_anno_labels/create";

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleRefresh = () => {
    setRefreshData(prev => prev + 1);
  };

  const handleDownload = async (selectedOnly = false) => {
    setDownloadInProgress(true);
    try {
      const token = localStorage.getItem('token');
      let url = `${process.env.REACT_APP_BACKEND_URL}/patients/segm_anno_labels/download/`;
      
      if (selectedOnly && selectedIds.length > 0) {
        url += `?ids=${selectedIds.join(',')}`;
      }
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Token ${token}`,
        },
      });
      
      if (!response.ok) {
        throw new Error('Download failed');
      }
      
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `segm_anno_labels_${selectedOnly ? 'selected' : 'all'}_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download error:', error);
      alert('Download failed. Please try again.');
    } finally {
      setDownloadInProgress(false);
      setShowDownloadDropdown(false);
    }
  };

  return (
    <div className="segm-anno-label-list-page">
      <Navbar />
      <div className="segm-anno-label-list-content">
        <div className="segm-anno-label-header-section">
          <h2>SegmAnno Labels</h2>
          <div className="button-group">
            <Link to={createLink} className="segm-anno-label-create-btn-main">
              New SegmAnno Label
            </Link>
            <button className="csv-import-btn" onClick={openModal}>
              CSV Import
            </button>
            
            <div className="download-dropdown-container">
              <button
                className="download-btn"
                onClick={() => setShowDownloadDropdown(!showDownloadDropdown)}
                disabled={selectedIds.length === 0 || downloadInProgress}
              >
                Download Selected ({selectedIds.length}) ▼
              </button>
              
              {showDownloadDropdown && (
                <div className="download-dropdown-menu">
                  <button 
                    onClick={() => handleDownload(true)}
                    disabled={downloadInProgress}
                  >
                    Download CSV
                  </button>
                  <button 
                    onClick={() => handleDownload(false)}
                    disabled={downloadInProgress}
                  >
                    Download All Data
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <SegmAnnoLabelList refreshData={refreshData} onSelectedIdsChange={setSelectedIds} />
      </div>

      <CSVImportModal
        type={"segm_anno_labels"}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSuccess={() => {
          handleRefresh();
          closeModal();
        }}
      />
    </div>
  );
};

export default SegmAnnoLabelListPage;
